<div class="icon-div"><i class="fa fa-trash fa-trash-circle" (click)="delete()"></i></div>
<div class="modal-header pt-4 pl-4 mb-0 border-0 modal-text">
    <h4 class="modal-text">{{modalText}}</h4>
  </div>
  <p class="revert mb-0 modal-text modal-body" [innerHtml]="modcontent"></p>
  <div class="modal-body p-0 modal-text">
  </div>
<div class="modal-footer mt-0">  
    <button type="button" class="btn btn-danger buttonModal" (click)="delete_user()" >Confirm</button>
    <button type="button" class="btn btn-primary buttonModal" (click)="delete()" >Cancel</button>
</div>
